import { render, staticRenderFns } from "./pubfooter.vue?vue&type=template&id=a595d53e&scoped=true"
import script from "./pubfooter.vue?vue&type=script&lang=js"
export * from "./pubfooter.vue?vue&type=script&lang=js"
import style0 from "./pubfooter.vue?vue&type=style&index=0&id=a595d53e&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a595d53e",
  null
  
)

export default component.exports